import { ReactElement, useContext, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthContext from "../../store/AuthContext";
import "../../assets/css/PageSurface.css";
import "../../assets/css/Text.css";
import "../../assets/css/InputText.css";
import { getManageDealList, ManageDealActor, ManageDealListResult } from "../../Services/ManageDealmaker";
import ManageDealmakerList from "./components/ManageDealmakerList";
import ManageDealmakerForm from "./components/ManageDealmakerForm";

function actorFrom(person: { legacyId?: string; firmLegacyId?: string; firmAdminAccess?: boolean; name?: string; lastName?: string }): ManageDealActor | null {
  if (!person.legacyId || !person.firmLegacyId) {
    return null;
  }
  return {
    contactId: String(person.legacyId),
    companyId: String(person.firmLegacyId),
    isFirmAdmin: Boolean(person.firmAdminAccess),
    firstName: person.name || "",
    lastName: person.lastName || "",
  };
}

export default function ManageDealmakerPage(): ReactElement {
  const { loggedPerson } = useContext(AuthContext);
  const [params] = useSearchParams();
  const action = params.get("action") || "";
  const dealId = params.get("id") || "";
  const actor = useMemo(() => (loggedPerson ? actorFrom(loggedPerson) : null), [loggedPerson]);
  const [list, setList] = useState<ManageDealListResult | null>(null);
  const [error, setError] = useState("");
  const showForm = action === "add" || action === "update";

  useEffect(() => {
    if (!actor || showForm) {
      return;
    }
    let cancelled = false;
    setError("");
    getManageDealList(actor)
      .then((result) => {
        if (!cancelled) {
          setList(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError("Firm deals could not be loaded.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [actor, showForm]);

  return (
    <div className="page-sheet">
      {!actor ? <p className="form-status">Sign in with a firm profile to manage deals.</p> : null}
      {actor && showForm ? <ManageDealmakerForm actor={actor} mode={action === "update" ? "update" : "add"} dealId={dealId} /> : null}
      {actor && !showForm && error ? <p className="form-status">{error}</p> : null}
      {actor && !showForm && !error && !list ? <p className="form-status">Loading firm deals.</p> : null}
      {actor && !showForm && list ? <ManageDealmakerList active={list.active} archived={list.archived} /> : null}
    </div>
  );
}
